import HowItWCard from './HowItWCard'
import './HowItWorks.css'

import work1 from '../assets/image/work1.jpg'
import work2 from '../assets/image/work2.jpg'
import work3 from '../assets/image/work3.jpg'


const hiwSteps = [
    {
        id: 1,
        image: work1,
        title: 'Share Your Team Vibe and Size',
        description: 'Help us understand your team dynamics and requirements.',
    },
    {
        id: 2,
        image: work2,
        title: 'Pick Your Theme / Package',
        description: 'Choose from a range of custom themes and packages.',
    },
    {
        id: 3,
        image: work3,
        title: 'We Plan + Host the Event. You Enjoy.',
        description: 'From planning to execution, we manage every detail, making sure your team has an unforgettable experience',
    },
];



export default function HowItWorks() {
    return (
        <>
            <div className='how-it-works-section'>
                <div className='container'>
                    <div className='how-it-works-wrapper'>
                        <div className='how-it-works-text'>
                            <h1>How It Works</h1>
                        </div>
                        <div className='how-it-works-content'>
                            <div className='how-it-works-content-num-section'>
                                <div className='how-it-works-content-num'>
                                    <div className='hiw-num-box'>
                                        1
                                    </div>

                                    <div className='hiw-line'></div>
                                    <div className='hiw-vertical-line'></div>

                                    <div className='hiw-num-box'>
                                        2
                                    </div>
                                    
                                     <div className='hiw-line'></div>
                                    <div className='hiw-vertical-line'></div>

                                    <div className='hiw-num-box'>
                                        3
                                    </div>
                                </div>
                            </div>

                            <div className='hiw-card-section'>
                                {hiwSteps.map(({ id, image, title, description }) => (
                                    <HowItWCard
                                        key={id}
                                        image={image}
                                        title={title}
                                        description={description}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
